function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useContext, useId, useRef, useState } from "react";
import Flicking from "@egjs/react-flicking";
import { twMerge } from "@stereoagency/tailwind-config";
import { Button, EntryAnimation } from "../../atoms";
import { LightArrowLeft, LightArrowRight } from "../../visuals";
import { useBreakpoint } from "../../hooks";
import { DotPagination } from "../DotPagination";
import ReactConfigContext from "../../ReactConfigContext";
export default function ImageGallery(param) {
    var images = param.images, accentColor = param.accentColor, className = param.className;
    var id = useId();
    var containerRef = useRef(null);
    var flickingRef = useRef(null);
    var _useState = _sliced_to_array(useState(0), 2), currentIndex = _useState[0], setCurrentIndex = _useState[1];
    var _useBreakpoint = useBreakpoint(), minWidth = _useBreakpoint.minWidth, BREAKPOINTS = _useBreakpoint.BREAKPOINTS;
    var _useContext = useContext(ReactConfigContext), ImageComponent = _useContext.config.ImageComponent;
    var slidesPerView = minWidth <= BREAKPOINTS.sm ? 1 : 3;
    var canGoBack = currentIndex > 0;
    var canGoForward = currentIndex < images.length - slidesPerView;
    var shouldShowArrows = images.length > 3;
    var handleBack = function() {
        if (flickingRef.current) {
            var _flickingRef_current;
            if (flickingRef.current.animating) {
                flickingRef.current.stopAnimation();
            }
            (_flickingRef_current = flickingRef.current) === null || _flickingRef_current === void 0 ? void 0 : _flickingRef_current.moveTo(Math.max(0, currentIndex - 1));
        }
    };
    var handleChange = function(event) {
        setCurrentIndex(event.index);
    };
    var handleMoveEnd = function(event) {
        setCurrentIndex(event.currentTarget.index);
    };
    var handleResize = function(event) {
        setCurrentIndex(event.currentTarget.index);
    };
    var handleForward = function() {
        if (flickingRef.current) {
            var _flickingRef_current;
            if (flickingRef.current.animating) {
                flickingRef.current.stopAnimation();
            }
            (_flickingRef_current = flickingRef.current) === null || _flickingRef_current === void 0 ? void 0 : _flickingRef_current.moveTo(Math.min(images.length - slidesPerView, currentIndex + 1));
        }
    };
    var handleGoto = function(index) {
        if (flickingRef.current) {
            var _flickingRef_current;
            if (flickingRef.current.animating) {
                flickingRef.current.stopAnimation();
            }
            (_flickingRef_current = flickingRef.current) === null || _flickingRef_current === void 0 ? void 0 : _flickingRef_current.moveTo(index);
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        ref: containerRef,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge("grid grid-cols-1 items-center md:gap-7 md:overflow-hidden", shouldShowArrows && "md:grid-cols-[auto_minmax(0px,1fr)_auto]")
    }, !!shouldShowArrows && /*#__PURE__*/ React.createElement("div", {
        className: "hidden md:block"
    }, /*#__PURE__*/ React.createElement(Button, {
        type: "icon-only",
        variant: "secondary",
        icon: /*#__PURE__*/ React.createElement(LightArrowLeft, null),
        disabled: !canGoBack,
        onClick: handleBack
    })), /*#__PURE__*/ React.createElement("div", {
        className: "-mx-4 overflow-hidden"
    }, /*#__PURE__*/ React.createElement(Flicking, {
        ref: flickingRef,
        bound: true,
        align: shouldShowArrows ? "prev" : "center",
        onWillChange: handleChange,
        onMoveEnd: handleMoveEnd,
        onChanged: handleChange,
        onAfterResize: handleResize
    }, images.map(function(img, imgIndex) {
        return /*#__PURE__*/ React.createElement("div", {
            key: "img-".concat(id, "-").concat(img.src),
            className: "flex px-4 w-4/5 md:w-1/3"
        }, /*#__PURE__*/ React.createElement(EntryAnimation, {
            view: containerRef,
            delay: imgIndex / 10,
            className: "flex w-full rounded-xl overflow-hidden safari-fix-transform [&>picture]:flex"
        }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, img), {
            sizes: "(min-width: 48em) 35vw, 100vw",
            className: twMerge("w-full object-cover object-center pointer-events-none", img.className)
        }))));
    }))), !!shouldShowArrows && /*#__PURE__*/ React.createElement("div", {
        className: "hidden md:block"
    }, /*#__PURE__*/ React.createElement(Button, {
        type: "icon-only",
        variant: "secondary",
        icon: /*#__PURE__*/ React.createElement(LightArrowRight, null),
        disabled: !canGoForward,
        onClick: handleForward
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "mt-5 md:hidden"
    }, /*#__PURE__*/ React.createElement(DotPagination, {
        active: currentIndex,
        count: images.length,
        accentColor: accentColor,
        onSelect: handleGoto
    })));
}

//# sourceMappingURL=ImageGallery.js.map